import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import "./manageOrganization.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  addPurchasedItem,
  baseUrl,
  getMaterialItam,
  getUnitAPI,
  updatePurchasedItem,
} from "api";
import { isValid } from "redux-form";
import { withTranslation } from "react-i18next";

class AddPurchasedItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      factoryList: [],
      itemList: [],
      selectedFiles: [],
      purchasedId: props?.location?.query ? props?.location?.query?.data?.id : "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: false, data: null },
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    if (
      this.state?.props?.data?.images &&
      this.state?.props?.data?.images != "null"
    ) {
      this.setState({
        selectedFiles: this.state.props.data.images.map(x => {
          return {
            preview: `${baseUrl}/uploads/${x}`,
          };
        }),
      });
    }
    const factory = await getUnitAPI({ isInternal: true });
    if (factory && factory.data) {
      this.setState({
        factoryList: factory.data.factories,
      });
    }
    const itemName = await getMaterialItam({ page: null, limit: null });
    if (itemName && itemName.data) {
      this.setState({
        itemList: itemName.data.items,
      });
    }
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit != true) {
      delete values.id;
      let formdata = new FormData();
      delete values.id;
      Object.keys(values).forEach(x => formdata.append(x, values[x]));
      if (this.state.selectedFiles.length)
        this.state.selectedFiles.forEach(x => {
          formdata.append("images", x);
        });
      const data = await addPurchasedItem(formdata);
      this.setState({ purchasedId: data.data.id });
    } else {
      console.log(values);
      let id = values.id;
      let formdata = new FormData();
      Object.keys(values).forEach(x => formdata.append(x, values[x]));
      if (this.state.selectedFiles.length) {
        formdata.delete("images");
        this.state.selectedFiles.filter(x => {
          if ("formattedSize" in x) return formdata.append("images", x);
        });
      }
      const data = await updatePurchasedItem({ data: formdata, id: id });
    }
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );
    console.log(this.state.selectedFiles);
    this.setState(
      { selectedFiles: [...this.state.selectedFiles, ...files] },
      () => console.log(this.state.selectedFiles)
    );
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Add Purchased Item")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-flex flex-row justify-content-between">
                      <div>
                        <h4 className="text-black fw-bold mb-5">
                          {this.props.t("Add Purchased Item Details")}
                        </h4>
                      </div>
                      {/* <div>
                        <div className="d-inline-block text-black fw-bold">
                          <label htmlFor="datePurchased" className="fs-5">
                            Purchased Date:
                          </label>
                          <input
                            type="date"
                            id="datePurchased"
                            name="datePurchased"
                            className="border-0 fs-4 ms-3 date-input"
                          />
                        </div>
                      </div> */}
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.props.data == null
                          ? {
                              factoryId:
                                (this.state && this.state.factoryId) || "",
                              sellerCompanyName:
                                (this.state && this.state.sellerCompanyName) ||
                                "",
                              piecesQuantity:
                                (this.state && this.state.piecesQuantity) || "",
                              itemId: (this.state && this.state.itemId) || "",
                              weight: (this.state && this.state.weight) || "",
                              warrantyDate:
                                (this.state && this.state.warrantyDate) || "",
                              expiryDate:
                                (this.state && this.state.expiryDate) || "",
                              cost: (this.state && this.state.cost) || "",
                            }
                          : {
                              factoryId: this.state.props.data.factoryId,
                              sellerCompanyName:
                                this.state.props.data.sellerCompanyName,
                              piecesQuantity:
                                this.state.props.data.piecesQuantity,
                              itemId: this.state.props.data.itemId,
                              id: this.state.props.data.id,
                              weight: this.state.props.data.weight,
                              warrantyDate: this.state.props.data.warrantyDate,
                              expiryDate: this.state.props.data.expiryDate,
                              cost: this.state.props.data.cost,
                            }
                      }
                      validationSchema={Yup.object().shape({
                        images: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        factoryId: Yup.string().required(
                          "This value is Required"
                        ),
                        sellerCompanyName: Yup.string()
                          .min(1)
                          .max(255)
                          .required("This value is Required"),
                        piecesQuantity: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("This value is Required"),
                        itemId: Yup.string()
                          .min(1)
                          .max(255)
                          .required("This value is Required"),
                        weight: Yup.number()
                          .min(1)
                          .max(32767)
                          .nullable()
                          .notRequired(),
                        warrantyDate: Yup.string().required(
                          "This value is Required"
                        ),
                        expiryDate: Yup.string().required(
                          "This value is Required"
                        ),
                        cost: Yup.number()
                          .min(1)
                          .required("This value is Required"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({
                        errors,
                        status,
                        touched,
                        values,
                        isValid,
                        validateForm,
                      }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Images")}
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <Dropzone
                                  onDrop={acceptedFiles => {
                                    this.handleAcceptedFiles(acceptedFiles);
                                  }}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div
                                      // style={{
                                      //   border:
                                      //     this.state.selectedFiles.length <
                                      //       1 && submitCount > 0
                                      //       ? "2px dashed red"
                                      //       : "",
                                      // }}
                                      className="dropzone"
                                    >
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop images here or click to upload.
                                        </h4>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                {/* {this.state.selectedFiles.length < 1 &&
                                  submitCount > 0 ? (
                                    <p className="text-danger">
                                      Please Upload Photo
                                    </p>
                                  ) : (
                                    <></>
                                  )} */}
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {this.state.selectedFiles?.map((f, i) => {
                                    return (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Purchase Item Id")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  value={this.state.purchasedId}
                                  type="text"
                                  name="id"
                                  placeholder="ITEM0000123"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="factoryId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Factory(Unit) Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.factoryId && touched.factoryId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="factoryId"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select factory Name
                                  </option>
                                  {this.state.factoryList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="factoryId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="sellerCompanyName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("seller Party")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.sellerCompanyName &&
                                    touched.sellerCompanyName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="sellerCompanyName"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="sellerCompanyName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="itemId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Item Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.itemId && touched.itemId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="itemId"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.itemList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="itemId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="piecesQuantity"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Pieces / Quantity")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.piecesQuantity &&
                                    touched.piecesQuantity
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="piecesQuantity"
                                  placeholder="12.56"
                                />
                                <ErrorMessage
                                  name="piecesQuantity"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Weight")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="weight"
                                  placeholder="12.56"
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="warrantyDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Warranty Date")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.warrantyDate && touched.warrantyDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="date"
                                  name="warrantyDate"
                                  placeholder="Enter Date"
                                />
                                <ErrorMessage
                                  name="warrantyDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="expiryDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Expiry Date")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.expiryDate && touched.expiryDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="date"
                                  name="expiryDate"
                                  placeholder="Enter Date"
                                />
                                <ErrorMessage
                                  name="expiryDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cost"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total Cost")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.cost && touched.cost
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cost"
                                  placeholder="₹250"
                                />
                                <ErrorMessage
                                  name="cost"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => {
                                  validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(event, values);
                                      }
                                    })
                                    .catch(err => console.log(err));
                                }}
                              >
                                {this.state.props.isEdit == true
                                  ? "Update"
                                  : "Submit"}
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AddPurchasedItem);
